import { render, staticRenderFns } from "./ExtranetUi.vue?vue&type=template&id=39cdbbcc&scoped=true"
import script from "./ExtranetUi.vue?vue&type=script&lang=ts"
export * from "./ExtranetUi.vue?vue&type=script&lang=ts"
import style0 from "./ExtranetUi.vue?vue&type=style&index=0&id=39cdbbcc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39cdbbcc",
  null
  
)

export default component.exports